import { useUSDateFormat } from '../../../../common/utils/timeUtil';

export const getSortedFormulaList = (hyperFormulaInstance: any): Array<string> =>
    hyperFormulaInstance
        .getRegisteredFunctionNames()
        .sort()
        .sort((a: string, b: string) => a.length - b.length);

export const isFormula = (text: string | null): boolean => !!text && text.toString().startsWith('=');

export const getHyperformulaDateFormats = (): Array<string> => {
    // Using the default values for US and non US
    return useUSDateFormat() ? ['MM/DD/YYYY', 'MM/DD/YY', 'YYYY/MM/DD'] : ['DD/MM/YYYY', 'DD/MM/YY'];
};
